import { addParkingTicket, removeParkingTicket } from "@app/store/actions/orderActions"
import { useGetStrings, useGetUpsellArticles } from "@app/store/service/cmsService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { getPriceString } from "@app/utils/localeUtils"
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons"
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus"
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip, useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useEffect, useState } from "react"
import OrderLine from "../OrderLine/OrderLine"
import OrderLines from "../OrderLines/OrderLines"

export function ParkingTickets({ formattedOrder, onAction, notEditable }) {
	const { data: loadedParkingTickets } = useGetUpsellArticles()
	const {
		data: { orderOverviewParkingTicket, moreInformation },
	} = useGetStrings(undefined, { defaultData: {} })
	const { sm, md } = useViewport()
	const parkingTickets = useSelector(state => state.order.parkingTickets)

	const [ticketPrice, setTicketPrice] = useState(0)
	const [cnt, setTicketCnt] = useState(0)

	const isEntranceType = detail =>
		detail.typeId === ORDER_LINE_TYPES.Ticket || detail.typeId === ORDER_LINE_TYPES.Object || detail.typeId === ORDER_LINE_TYPES.ObjectGroup
	const hasEntrance = formattedOrder
		? formattedOrder.orderLines.filter(orderLine => orderLine.details.filter(e => isEntranceType(e)).length > 0).length > 0
		: false

	useEffect(() => {
		if (loadedParkingTickets) {
			let price = 0
			let cnt = 0
			if (formattedOrder) {
				formattedOrder.orderLines.forEach(orderLine => {
					let details = orderLine.details.filter(e => loadedParkingTickets.find(a => a.ticketId == e.ticketId))
					if (details.length && orderLine.quantity > 0) {
						price = details[0].amounts[0].grossAmount
						cnt = details[0].quantity
					}
				})
			}

			setTicketCnt(cnt)
			setTicketPrice(price)
		}
	}, [loadedParkingTickets, formattedOrder])

	if (!hasEntrance && formattedOrder) {
		return null
	}

	if (loadedParkingTickets && loadedParkingTickets.length > 0) {
		if (notEditable) {
			let ticketLine = formattedOrder.orderLines.find(
				e => e.details[0].typeId === ORDER_LINE_TYPES.Ticket && loadedParkingTickets.filter(a => a.ticketId == e.details[0].ticketId).length,
			)
			if (!ticketLine) {
				return null
			}
			return (
				<OrderLines>
					<OrderLine orderLine={ticketLine} />
				</OrderLines>
			)
		}

		return (
			<div className="mt-4">
				<div className="color-bg-secondary-100">
					{!notEditable && (
						<div className="flex flex-items-center p-3 regular color-fg-secondary f4">
							<h2 id="order-overview-parking-tickets-title" className="h-without-default-style">
								{orderOverviewParkingTicket}
							</h2>
							<Tooltip text={loadedParkingTickets[0].detail_Information} position="top" showArrow>
								<span className="ml-2" tabIndex={0} role="button" aria-label={moreInformation}>
									<FontAwesomeIcon icon={faQuestionCircle} />
								</span>
							</Tooltip>
						</div>
					)}

					<OrderLines ariaLabelledBy="order-overview-parking-tickets-title">
						{loadedParkingTickets.map((ticket, index) => {
							return (
								<li key={index} className="flex flex-justify-between flex-items-center f5">
									<div className="regular">
										{ticket.name} {getPriceString(ticket.price)}
									</div>
									<div className="flex flex-items-center" style={{ userSelect: "none" }}>
										<div className="flex flex-items-center">
											{(parkingTickets[ticket.ticketId] || cnt > 0) && !notEditable && (
												<button
													className="counter-btn color-fg-primary flex flex-center circle border color-border-primary f5 p-1 clickable"
													onClick={() => {
														removeParkingTicket(ticket)
														onAction()
													}}
													style={{
														height: "24px",
														width: "24px",
													}}
												>
													<FontAwesomeIcon icon={faMinus} />
												</button>
											)}

											<div className="f4 mx-2 text-center" style={{ width: "15px" }}>
												{cnt}
											</div>
											{!notEditable && (
												<button
													className="counter-btn color-fg-primary flex flex-center circle border color-border-primary f5 p-1 clickable"
													onClick={() => {
														addParkingTicket(ticket)
														onAction()
													}}
													style={{
														height: "24px",
														width: "24px",
													}}
												>
													<FontAwesomeIcon icon={faPlus} />
												</button>
											)}
										</div>
										<div style={{ width: sm || md ? "50px" : "100px" }} className="regular text-right">
											{getPriceString(ticketPrice)}
										</div>
									</div>
								</li>
							)
						})}
					</OrderLines>
				</div>
			</div>
		)
	} else {
		return null
	}
}
